import Axios from 'axios'
import {bookingTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_booking_types (context) {
    Axios.get(bookingTypeUrls.getAllBookingTypes).then(function (response) {
      context.commit('GET_ALL_BOOKING_TYPES', response.data)
    })
  },
  get_booking_types (context, publicId) {
    Axios.get(bookingTypeUrls.getBookingTypes + publicId).then(function (response) {
      context.commit('GET_BOOKING_TYPES', response.data)
    })
  },
  get_deleted_booking_types (context) {
    Axios.get(bookingTypeUrls.getDeletedBookingType).then(function (response) {
      context.commit('GET_DELETED_BOOKING_TYPES', response.data)
    })
  },
  get_booking_type (context, publicId) {
    Axios.get(bookingTypeUrls.getBookingType + publicId).then(function (response) {
      context.commit('GET_BOOKING_TYPE', response.data)
    })
  },
  post_booking_type (context, data) {
    Axios.post(bookingTypeUrls.postBookingType, data).then(function () {
      context.dispatch('get_all_booking_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_booking_type (context, data) {
    Axios.patch(bookingTypeUrls.editBookingType, data).then(function () {
      context.dispatch('get_all_booking_types')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_booking_type (context, data) {
    Axios.patch(bookingTypeUrls.deleteBookingType, data).then(function (response) {
      context.dispatch('get_all_booking_types')
      context.commit('GET_DELETED_BOOKING_TYPES', response.data)
    })
  },
  restoreBookingType (context, publicId) {
    Axios.get(bookingTypeUrls.restoreBookingType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_BOOKING_TYPES', response.data)
      router.push({
        name: 'Module.BookingTypes'
      })
    })
  }
}
